import { CareerBuilderSearch } from 'wisestep-api';

import BasicSearchForm from '../../types/IBasicSearchForm';
import ICareerBuilderAdvanceSearch from '../types/ICareerBuilderAdvanceSearch';

export default function (values: BasicSearchForm & ICareerBuilderAdvanceSearch) {
  let orderBy = '-RELV';
  if (values.sort) {
    switch (values.sort) {
      case 'relevancy':
        orderBy = '-RELV';
        break;
      case 'activityDate':
        orderBy = '-LASTACTIVITYDT';
        break;
      case 'dateResumeLastUpdated':
        orderBy = '-MODIFIEDINT';
        break;
      default:
    }
  }

  const query: CareerBuilderSearch = {
    accountId: values.accountId,
    pageNumber: values.page,
    pageSize: values.pageSize,
    orderBy: orderBy,
    searchPattern: 'Any',
    searchRadiusInMiles: '',
    freshnessInDays: '',
    keywords: '',
    applyLastActivity: true,
    cbMinimumExperience: '',
    cbMaximumExperience: '',
    jobTitle: '',
    company: '',
    onlyWithZipCode: '',
    minimumDegree: '',
    languagesSpoken: '',
    employmentType: '',
    country: '',
    workStatus: '',
    compensationType: '',
    minimumSalary: '',
    maximumSalary: '',
    securityClearance: '',
    currentlyEmployed: '',
    managementExperience: '',
    minimumEmployeesManaged: '',
    workPermitLocation: '',
    minimumTravelRequirement: '',
    locations: values.locations ?? [],
  };

  if (values.query) {
    query.keywords = values.query;
  }

  if (values.searchPattern) {
    query.searchPattern = values.searchPattern;
  }

  const { totalExperience } = values;
  if (totalExperience.min) {
    query.cbMinimumExperience = totalExperience.min;
  }
  if (totalExperience.max) {
    query.cbMaximumExperience = totalExperience.max;
  }

  if (values.distance) {
    query.searchRadiusInMiles = '' + values.distance;
  }

  if (values.jobTitle.values.length) {
    query.jobTitle = values.jobTitle.values.join(` ${values.jobTitle.matchType} `);
  }

  if (values.companies.values.length) {
    query.company = values.companies.values.join(` ${values.companies.matchType} `);
  }

  if (values.zipcode) {
    query.onlyWithZipCode = values.zipcode;
  }

  if (values.minimumDegree.length) {
    query.minimumDegree = values.minimumDegree.join(',');
  }

  if (values.languages.length) {
    query.languagesSpoken = values.languages.join(' AND ');
  }

  if (values.employmentType.length) {
    query.employmentType = values.employmentType.join('|');
  }

  if (values.authorizedCountries.length) {
    query.country = values.authorizedCountries.join(',');
  }

  if (values.workAuthorization.length) {
    query.workStatus = values.workAuthorization.join(',');
  }

  if (values.salaryRange) {
    if (values.salaryRange.unitTime) {
      query.compensationType = values.salaryRange.unitTime;
    }
    if (values.salaryRange.min) {
      query.minimumSalary = values.salaryRange.min;
    }
    if (values.salaryRange.max) {
      query.maximumSalary = values.salaryRange.max;
    }
  }

  if (values.hasSecurityClearance !== null) {
    query.securityClearance = values.hasSecurityClearance;
  }

  if (values.currentlyEmployed !== null) {
    query.currentlyEmployed = values.currentlyEmployed;
  }

  if (values.managementExperience !== null) {
    query.managementExperience = values.managementExperience;
  }
  if (values.minEmployeeManaged !== null) {
    query.minimumEmployeesManaged = values.minEmployeeManaged;
  }

  if (values.militaryExperience.length) {
    query.workPermitLocation = values.militaryExperience.join(',');
  }

  if (values.travelPreference.toString() !== '') {
    query.minimumTravelRequirement = values.travelPreference;
  }

  if (values.applyLastActivity !== null) {
    query.applyLastActivity = values.applyLastActivity;
  }

  if (values.lastActive) {
    query.freshnessInDays = values.lastActive;
  }
  return query;
}
